import { TMenuConfig } from "../common/menu";

export const MENU_SIDEBAR: TMenuConfig = [
    {
        title: 'PROFILE',
        path: '/user'
    },
    {
        title: 'MEMBERSHIP',
        path: '/user/membership'
    },
    {
        title: 'EXTENSION_BUILDER',
        path: '/user/extension_builder'
    },
    {
        title: 'ELEMENT_BUILDER',
        path: '/user/element_builder'
    },
    {
        title: 'T3THEMES',
        path: '/user/t3themes'
    },
    {
        title: 'T3HEADLESS',
        path: '/user/t3headless'
    },
    {
        title: 'SIDEBAR.PACKAGE_BUILDER',
        path: '/user/package_builder'
    },
];
